import { CountUp } from 'countup.js';

document.addEventListener("DOMContentLoaded", function() {
	const numbers = document.querySelectorAll('.number-large');

	const observer = new IntersectionObserver((entries, observer) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				const element = entry.target;
				const endVal = element.textContent.replace(/[^\d.]/g, '');

				const countUp = new CountUp(element, endVal, {
					duration: 3,
					useEasing: true,
					useGrouping: true,
					separator: ',',
					decimal: '.',
				});

				if (!countUp.error) {
					countUp.start();
				} else {
					console.error(countUp.error);
				}

				observer.unobserve(element);
			}
		});
	}, {
		threshold: 0.5
	});

	numbers.forEach(number => {
		observer.observe(number);
	});
});
